<template>
  <div class="module-properties">
    <div class="form-group">
      <label>Tipo de Transformação</label>
      <select v-model="config.transformationType">
        <option value="format">Formatação</option>
        <option value="replace">Substituição</option>
        <option value="calculate">Cálculo</option>
        <option value="filter">Filtro</option>
      </select>
    </div>
    
    <div class="form-group" v-if="config.transformationType === 'format'">
      <label>Campo</label>
      <input type="text" v-model="config.field" placeholder="Nome do campo">
    </div>
    
    <div class="form-group" v-if="config.transformationType === 'format'">
      <label>Formato</label>
      <select v-model="config.format">
        <option value="date">Data</option>
        <option value="number">Número</option>
        <option value="text">Texto</option>
      </select>
    </div>
    
    <div class="form-group" v-if="config.transformationType === 'replace'">
      <label>Campo</label>
      <input type="text" v-model="config.field" placeholder="Nome do campo">
    </div>
    
    <div class="form-group" v-if="config.transformationType === 'replace'">
      <label>Valor Original</label>
      <input type="text" v-model="config.oldValue" placeholder="Valor a ser substituído">
    </div>
    
    <div class="form-group" v-if="config.transformationType === 'replace'">
      <label>Novo Valor</label>
      <input type="text" v-model="config.newValue" placeholder="Novo valor">
    </div>
    
    <div class="form-group" v-if="config.transformationType === 'calculate'">
      <label>Expressão</label>
      <input type="text" v-model="config.expression" placeholder="Ex: campo1 + campo2">
    </div>
    
    <div class="form-group" v-if="config.transformationType === 'calculate'">
      <label>Campo de Destino</label>
      <input type="text" v-model="config.targetField" placeholder="Nome do campo de destino">
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransformModuleProperties',
  props: {
    module: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      config: {
        transformationType: 'format',
        field: '',
        format: 'date',
        oldValue: '',
        newValue: '',
        expression: '',
        targetField: '',
        ...this.module.config
      }
    };
  },
  watch: {
    config: {
      handler(newConfig) {
        this.$emit('update:config', newConfig);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.module-properties {
  padding: 10px;
}
.form-group {
  margin-bottom: 15px;
}
label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}
select, input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>
